import React from "react";
import { Form, Select, DatePicker, Checkbox, Button, Switch } from "antd";
import { DAYS_OF_WORK, TIME_FORMAT } from "../../../../constants";
import moment from "moment";

const { DATE } = TIME_FORMAT;
const { RangePicker } = DatePicker;
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;

const RepeatTimeForm = ({
  setSelectedDays,
  repeatedScheduleInfo,
  setRepeatedScheduleInfo,
  isPrivate,
  setIsPrivate,
}) => {
  const { repeatedWeeks, startDate, endDate, daysOfWeek } = repeatedScheduleInfo;

  const handleRepeatedScheduleInfoChange = (value) => {
    setRepeatedScheduleInfo({
      ...repeatedScheduleInfo,
      ...value,
    });
  };

  const generateWeekDays = (repeatedWeeks, startDate) => {
    let dates = [];
    let lastDate = startDate;
    daysOfWeek.forEach((weekNumber) => {
      const date = startDate.clone().day(weekNumber + repeatedWeeks * 7);
      if (date.diff(startDate) >= 0 && endDate.diff(date) >= 0) {
        dates.push(date);
      }
      lastDate = date;
    });

    return { dates, lastDate };
  };

  const generateFirstWeekDays = () => {
    let { dates, lastDate } = generateWeekDays(0, startDate);
    if (dates.length < 1) {
      const result = generateWeekDays(1, lastDate);
      dates = result.dates;
      lastDate = result.lastDate;
    }

    return { dates, lastDate };
  };

  const syncCalendar = () => {
    if (repeatedWeeks && startDate && endDate && daysOfWeek.length > 0) {
      let { dates: days, lastDate: lastDay } = generateFirstWeekDays();
      while (endDate.diff(lastDay) >= 0) {
        const { dates, lastDate } = generateWeekDays(repeatedWeeks, lastDay);
        days = [...days, ...dates];
        lastDay = lastDate;
      }

      setSelectedDays(days.map((day) => moment(day).format(DATE)));
    }
  };

  const handleUpdateCalendar = () => {
    syncCalendar();
  };

  return (
    <>
      <Form.Item className="repeat-schedule" label="Schedule Frequency">
        Repeat every{" "}
        <Select
          defaultValue="1"
          style={{ width: 60 }}
          onChange={(value) => handleRepeatedScheduleInfoChange({ repeatedWeeks: value })}
          value={repeatedWeeks}
        >
          {[...Array(5).keys()].slice(1).map((key) => (
            <Option key={key} value={key}>
              {key}
            </Option>
          ))}
        </Select>
        <span>{` week${repeatedWeeks > 1 ? "s" : ""}`}</span>
      </Form.Item>

      <Form.Item className="repeat-schedule" label="Date Range">
        <RangePicker
          value={[startDate, endDate]}
          onChange={([startDate, endDate]) => handleRepeatedScheduleInfoChange({ startDate, endDate })}
        />
      </Form.Item>

      <Form.Item label="is private" name="isPrivate">
        <Switch defaultChecked={false} checked={isPrivate} onChange={(checked) => setIsPrivate(checked)} />
      </Form.Item>

      <Form.Item className="repeat-schedule" label="Days Active">
        <CheckboxGroup
          options={DAYS_OF_WORK}
          value={daysOfWeek}
          onChange={(list) => handleRepeatedScheduleInfoChange({ daysOfWeek: list })}
        />
      </Form.Item>

      <Button onClick={handleUpdateCalendar}>sync to calendar</Button>
    </>
  );
};

export default RepeatTimeForm;
